import React, { useEffect, useState } from "react";
import UserEditRights from "./UserEditRights";
import { useLoading } from "../../../common/LoadingContext";
import { useNotificationContext } from "../../../common/NotificationContext";
import {
  UserRolesDetailsService,
  UserRoleAccessService,
  AddRoleAccessService,
} from "../../../services/UserOnboardingService";
import useGlobalState from "../../../Context";

const EditRightsMainFile = () => {
  const [userRolesDetails, setUserRolesDetails] = useState([]);
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserInfo = auth.ldapParam;

  useEffect(() => {
    fetchUserRolesDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchUserRolesDetails = async (page) => {
    try {
      setLoading(true);
      const response = await UserRolesDetailsService();
     // console.log('response',response)
      if (response.statusCode === 6) {
        if (loginUserInfo.userType === "Domain Admin") {
          const dept = response.data.find(
            (item) => item.deptName === loginUserInfo.department
          );     
          setUserRolesDetails([dept]);
        } else {
          setUserRolesDetails(response.data);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };
  return (
    <UserEditRights
      userRolesDetails={userRolesDetails}
      UserRoleAccessService={UserRoleAccessService}
      setLoading={setLoading}
      showNotification={showNotification}
      AddRoleAccessService={AddRoleAccessService}
      loginUserInfo={loginUserInfo}
    />
  );
};

export default EditRightsMainFile;
